import { TTransitionDeclaration } from './types';

export const DURATION = 300;
export const EASING = 'cubic-bezier(0.23, 1, 0.32, 1)';
export const VERTICAL_OFFSET = 16;

export const definedTransitions = (
  duration = DURATION,
  easing = EASING,
  verticalOffset = VERTICAL_OFFSET,
  stackIndex = 0
): TTransitionDeclaration => ({
  slideUp: {
    base: {
      transition: `transform ${duration}ms ${easing}`,
      transform: `translate3d(0, ${verticalOffset * 2}px, 0)`,
    },
    transition: {
      entering: {},
      entered: {
        transform:
          stackIndex > 0
            ? `translate3d(0, ${stackIndex * (verticalOffset / 2)}px, 0)`
            : 'none',
      },
      exiting: {
        transform: `translate3d(0, -${verticalOffset * 2}px, 0)`,
      },
      exited: {},
    },
  },
  fade: {
    base: {
      transition: `opacity ${duration / 2}ms`,
    },
    transition: {
      entering: { opacity: 0 },
      entered: { opacity: 1 },
      exiting: { opacity: 0 },
      exited: { opacity: 0 },
    },
  },
  slideRight: {
    base: {
      transition:
        `transform ${duration}ms ${easing}, ` + `width ${duration}ms ${easing}`,
      transform: 'translate3d(-100%,0,0)',
    },
    transition: {
      entering: {},
      exiting: {},
      entered: { transform: undefined },
      exited: {
        transform: 'translate3d(-100%,0,0)',
      },
    },
  },
});
